<template>
  <div>
    {{ msg }}
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },
  async mounted() {
    // if (!localStorage.getItem("openid")) {
    //   location.href = `https://plusapi.51i.cc/api/Oauth2/authorize?redirect_uri=${location.href}`;
    // }
  },
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/index.vue